import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-help_symbol",
  "use": "icon-help_symbol-usage",
  "viewBox": "0 0 13.75 29.375",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.75 29.375\" id=\"icon-help_symbol\">\n  <defs>\n    <style>\n      #icon-help_symbol .cls-1 {\n        fill: currentColor;\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-help_symbol_符号_主题色\" class=\"cls-1\" d=\"M38.813,217.986V205.173H31.938q0-7.5,7.813-11.875v-4.687Q26,193.3,26,206.736v11.25H38.813Z\" transform=\"translate(-26 -188.625)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol